import { createClient } from "@supabase/supabase-js";

const url = process.env.REACT_APP_SUPABASE_URL;
const key = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Null when env vars aren't set — callers guard with `if (!supabase)`.
export const supabase = url && key ? createClient(url, key) : null;
